import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'

const renderList = (list) => {
  return (
    Object.keys(list).map(item => {
      return (<option key={list[item].id} value={list[item].id}>{list[item].name}</option>);
    })
  );
};

const UpsellPopupsSearchPanel = (props) => {
  const {productValue, onProductChange, productList, onApply, onClearFilters} = props;
  return (
    <Panel className="order-filter">
      <Row>
        <Col md={8}>
          <FormGroup>
            <FormControl
              value={productValue}
              onChange={onProductChange}
              componentClass="select">
              <option value="">[Product]</option>
              { renderList(productList) }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={4} className="actions">
          <Button
            className="red-ghost-btn"
            onClick={onApply}>Apply</Button>
          <Button
            className="red-ghost-btn"
            onClick={onClearFilters}>Clear filters</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default UpsellPopupsSearchPanel;



// WEBPACK FOOTER //
// ./src/components/admin/promotions/upsell_popups/list/upsell-popups-search-panel.jsx